import { render, staticRenderFns } from "./SimulatorLayer.vue?vue&type=template&id=0883d5ee&scoped=true&"
import script from "./SimulatorLayer.vue?vue&type=script&lang=js&"
export * from "./SimulatorLayer.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorLayer.vue?vue&type=style&index=0&id=0883d5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883d5ee",
  null
  
)

export default component.exports